import {NavLink} from "react-router-dom";
import React from "react";

type ButtonGradientProps = {
    link?: string,
    text: string,
    icon?: React.ReactNode,
    background?: string,
    backgroundHover?: string,
    color?: string,
    openInNewWindow?: boolean,
    callbackFunction?: () => void,
    className?: string,
    disabled?: boolean,
    onClick?: (e: any) => void,
}

const ButtonPillGradient: React.FC<ButtonGradientProps> = (
    {
        link = '',
        text = 'Click Here',
        icon,
        background = 'linear-gradient(90deg, rgba(232,187,39) 0%, rgba(229,174,44) 100%)',
        backgroundHover = '',
        color = 'black',
        openInNewWindow = false,
        className = '',
        disabled = false,
        onClick = () => {},
    }
) => {
    return link && link !== '' ? (

            <NavLink
                to={link}
                className={`ickonic-button button ickonic-button--gradient u-relative_hidden ${className}`}
                target={openInNewWindow ? "_blank" : "_self"}
                onClick={onClick}
                style={{
                    color,
                }}
            >
                <div className="ickonic-button__inner">
                    <span>{text}</span>
                    {icon && icon}
                    <div className="u-full_cover_absolute" style={{background}}/>
                    <div className="u-full_cover_absolute"
                         style={{background: backgroundHover !== "" ? backgroundHover : background}}/>
                </div>
            </NavLink>
        )
        :
        (
            <button
                className={`ickonic-button button ickonic-button--gradient u-relative_hidden ${className}`}
                onClick={onClick}
                disabled={disabled}
                style={{
                    color,
                }}
            >
                <div className="ickonic-button__inner">
                    <span>{text}</span>
                    {icon && icon}
                    <div className="u-full_cover_absolute" style={{background}}/>
                    <div className="u-full_cover_absolute"
                         style={{background: backgroundHover !== "" ? backgroundHover : background}}/>
                </div>
            </button>
        )
};

export default ButtonPillGradient;
